export class Line{
    public Rate = 0.1;
    public TimeRemaining = 600;
    public VolumeInfused = 0;
    public VolumeRemaining = 1;
    public DrugLabel = '';
}